module.exports = __webpack_public_path__ + "img/2.06ea01fb.png";